import _ from 'lodash'

// 防抖 - 等一会儿再执行
export function _debounce(time, fn, delay = 500) {
  // let time;
  return function () {
    let context = this;
    let args = arguments;
    if(time !== null) clearTimeout(time);
    time = setTimeout(() => {
      fn.apply(context, args);
    }, delay);
  }
}

// 节流 - 执行后的一段时间内都不重复执行
export function _throttle(last, time, now, fn, wait = 500) {
  // let last, time, now;
  return function() {
    let context = this;
    now = new Date();
    if(last && now - last < wait) {
      clearTimeout(time);
      time = setTimeout(() => {
        last = now;
        fn.call(context, ...arguments);
      }, wait);
    } else {
      last = now;
      fn.call(context, ...arguments);
    }
  }
}

// 时间戳转换
export function _formatDate(timestamp, type='date') {
  let date = new Date(parseInt(timestamp));
  const Y = date.getFullYear() + '-';
  const M = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) + '-' : date.getMonth() + 1 + '-';
  const D = date.getDate() < 10 ? '0' + date.getDate() + ' ' : date.getDate() + ' ';
  const h = date.getHours() < 10 ? '0' + date.getHours() + ':' : date.getHours() + ':';
  const m = date.getMinutes() < 10 ? '0' + date.getMinutes() + ':' : date.getMinutes() + ':';
  const s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
  return type === 'date' ? Y + M + D :
    type === 'time' ? Y + M + D + h + m + s : '-';
}

// 通过key获取value
export function _getKeyByValue(obj, value, compare = (a, b) => a === b) {
  return Object.keys(obj).find(key => compare(obj[key], value));
}

// diff函数
export function _diff(nVal, oVal) {
  return _.reduce(nVal, (result, value, key) => {
    if (!_.isEqual(value, oVal[key])) {
      result[key] = value;
    }
    return result;
  }, []);
}



// WEBPACK FOOTER //
// ./src/util/common.js